export default __webpack_public_path__ + "images/value_tags/vegan-271fb500d0a9e43fce4ff1ed3e551dc6.svg";